import React, { FC } from 'react';
import styled from 'styled-components';
import { CustomerTiles } from '../../components/CustomerTiles';
import { PageHeading } from '../../components/page-heading/page-heading';
import { IOrder, IShipTo, ISoldTo } from '../../graphql/types';
import { useLocalStorage } from '../../hooks/use-local-storage';
import { White } from '../../styles/colours';
import { Medium } from '../../styles/fonts';
import { GetFirstFiveOrdersQuery } from '../orders/queries/first-five-orders';
import { OrdersTable } from '../orders/table/table';
import { SoldToPageBreadcrumb } from './breadcrumbs';
import { SoldToSearchControls } from './search-controls';

const StyledTopSection = styled.div`
  background-color: ${White};
  padding: 0rem 0rem 3rem 7.5rem;
`;

const StyledBottomSection = styled.div`
  padding: 0rem 7.5rem 3rem 7.5rem;
`;

const StyledStaticText = styled.span`
  font-family: ${Medium};
  font-size: 1rem;
  margin: 1rem;
  float: right;
`;

export const SoldToBody: FC<{ soldTo: ISoldTo; shipTo?: IShipTo }> = ({
  soldTo,
  shipTo,
}) => {
  const [firstFiveOrdersToggle, setFirstFiveOrdersToggle] = useLocalStorage(
    'firstFiveOrdersToggle',
    false
  );
  const setToggle = () => {
    setFirstFiveOrdersToggle(!firstFiveOrdersToggle);
  };
  return (
    <>
      <StyledTopSection>
        <SoldToPageBreadcrumb soldTo={soldTo} />
        <PageHeading>Sold-To details</PageHeading>
        <CustomerTiles
          soldTo={soldTo}
          shipTo={shipTo}
          isVmiSite={shipTo?.vmiIndicator}
        />
      </StyledTopSection>
      <StyledBottomSection>
        <SoldToSearchControls
          soldTo={soldTo}
          shipTo={shipTo}
          firstFiveOrdersToggle={firstFiveOrdersToggle}
          setToggle={setToggle}
        />
        {firstFiveOrdersToggle && (
          <GetFirstFiveOrdersQuery
            shipToId={shipTo?.id}
            soldToId={soldTo.id}
            render={(orders: IOrder[]) => {
              return (
                <>
                  <OrdersTable orders={orders} />
                  <StyledStaticText>
                    ⃰⃰⃰ The table shows the latest five or fewer orders from the
                    last 30 days
                  </StyledStaticText>
                </>
              );
            }}
          />
        )}
      </StyledBottomSection>
    </>
  );
};
